module.exports = __webpack_public_path__ + "img/pattern-1.80844eef.svg";